import Vue from "vue";
import VueRouter from "vue-router";

import LoginComponent from "@/components/utils/LoginComponent.vue";
import HomePage from "@/components/pages/HomePage.vue";
import AlarmsPage from "@/components/pages/AlarmsPage.vue";
import HistoryPage from "@/components/pages/NewHistoryPage.vue";
import VariatorView from "@/components/utils/VariatorView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Página principal",
          content: "Página principal de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent,
    meta: {
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Login",
          content: "Página de login de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/alarms",
    name: "alarmas",
    component: AlarmsPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Alarmas",
          content: "Página de alarmas de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/history",
    name: "history",
    component: HistoryPage,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Histórico",
          content: "Página de histórico de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
  {
    path: "/variadores",
    name: "variadores",
    component: VariatorView,
    meta: {
      requiresAuth: true,
      title: process.env.VUE_APP_TITLE,
      metaTags: [
        {
          name: "Variadores",
          content: "Página de Variadores de " + process.env.VUE_APP_COMPANY,
        },
      ],
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = `${to.meta.title} - ${to.meta.metaTags[0].name}`;
  }

  const loggedIn = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth) && !loggedIn) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
